import type { SkillVersion } from "@/hooks/use-skill";
import { timeAgo } from "@/lib/skills/time-ago";
import { cn } from "@/lib/utils";

export function VersionTimeline({ history }: { history: SkillVersion[] }) {
  if (history.length === 0) {
    return <p className="text-sm text-fg-3">No version history yet.</p>;
  }
  return (
    <ol className="flex flex-col gap-4">
      {history.map((v, i) => (
        <li key={v.id} className="flex gap-3">
          <span
            className={cn(
              "mt-1 size-2.5 shrink-0 rounded-full",
              i === 0 ? "bg-fg-link" : "bg-border-2",
            )}
          />
          <div>
            <div className="flex items-center gap-2 text-sm font-semibold text-fg-1">
              <span className="font-mono">v{v.v}</span>
              {i === 0 ? (
                <span className="rounded-full bg-bg-2 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-fg-link">
                  Current
                </span>
              ) : null}
            </div>
            <div className="text-xs text-fg-3">{timeAgo(new Date(v.createdAt))}</div>
            {v.notes ? <p className="mt-1 text-sm text-fg-2">{v.notes}</p> : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
